import { Controller } from 'stimulus';

class Ticker extends Controller {
  connect() {
    this.texts = this.element.getAttribute('data-ticker-texts')
      ? JSON.parse(this.element.getAttribute('data-ticker-texts'))
      : null;

    this.activeLine = 0;
    this.activeCharacter = 0;
    this.endReached = false;

    // How fast each characters shows up in milliseconds
    this.characterSpeed = 90;

    // Start again after reaching the last line
    this.loop = false;

    // Wait before starting the initial ticker (to give the page time to load)
    this.initialWait = this.data.get('initial-wait') ?? 2000;

    // Amount of time to wait after the end of the line is reached in milliseconds
    this.waitAfterLineEnd = 2000;

    // If the last character should have a pulse/flicker animation
    this.pulseLastCharacter = true;

    // The last characters that can pulse/flicker (to prevent regular letter from flashing)
    this.pulseCharacters = ['_', '.'];

    if (!this.texts || !Array.isArray(this.texts) || this.texts.length < 1) {
      this.element.style.opacity = '1';
      return;
    }

    // Retrieve the max height by checking all lines, to prevent the element from
    // jumping up and down.
    const maxHeight = this.calculateMaxHeight();

    if (!maxHeight) {
      this.element.style.opacity = '1';
      return;
    }

    this.element.style.opacity = '1';
    this.element.style.minHeight = `${maxHeight}px`;
    this.element.innerHTML = '&nbsp;';

    setTimeout(() => {
      this.startTicker();
    }, this.initialWait);
  }

  startTicker() {
    this.tickerInterval = setInterval(() => {
      this.onTick();
    }, this.characterSpeed);
  }

  onTick() {
    if (this.endReached) {
      return;
    }

    this.activeCharacter += 1;

    const line = this.texts[this.activeLine].substr(0, this.activeCharacter);

    this.outputLine(line);

    if (line === this.texts[this.activeLine]) {
      this.endReached = true;

      this.setupPulse();

      setTimeout(() => {
        this.endReached = false;

        if (this.lastCharacterPulseInterval) {
          clearInterval(this.lastCharacterPulseInterval);
        }
      }, this.waitAfterLineEnd);

      this.onEndOfLineReached();
    }
  }

  onEndOfLineReached() {
    this.activeLine += 1;
    this.activeCharacter = 0;

    // If the new active line is equal to the amount of lines, reset the ticker
    if (this.activeLine === this.texts.length) {
      if (!this.loop) {
        clearInterval(this.tickerInterval);
      }

      this.activeLine = 0;
    }
  }

  setupPulse() {
    if (!this.pulseLastCharacter) {
      return;
    }

    const line = this.texts[this.activeLine];
    const lastCharacter = line[line.length - 1];

    if (this.pulseCharacters.indexOf(lastCharacter) < 0) {
      return;
    }

    // Add a span around the last character with a class that makes it pulse (keyframes in CSS)
    const lineWithAnimation = `${line.substr(0, line.length - 1)}<span class="ticker-pulse">${lastCharacter}</span>`;

    this.outputLine(lineWithAnimation);
  }

  outputLine(text) {
    this.element.innerHTML = text;
  }

  calculateMaxHeight() {
    let maxHeight = 0;

    this.texts.forEach((text) => {
      this.element.innerText = text;

      if (this.element.offsetHeight > maxHeight) {
        maxHeight = this.element.offsetHeight;
      }
    });

    return maxHeight;
  }
}

Ticker.targets = [
  //
];

export default Ticker;
